import React, { useEffect, useState } from "react";
import BannerSlider from "../components/BannerSlider";
import ProgramCard from "../components/ProgramCard";
import AboutSection from "../components/AboutSection";
import StatsSection from "../components/StatsSection";
import PartnershipsSection from "../components/PartnershipsSection";
import NewsSection from "../components/NewsSection";
import VideosSection from "../components/VideosSection";
import PlatformsSection from "../components/PlatformsSection";

import publicidadImg from "../assets/images/publicidad/popup.jpg";
import "./Home.css";


//  Imágenes locales
import construccionImg from "../assets/images/programas_estudio/civil.jpg";
import contabilidadImg from "../assets/images/programas_estudio/contabilidad.jpg";
import desarrolloImg from "../assets/images/programas_estudio/sistemas.jpg";
import electricidadImg from "../assets/images/programas_estudio/electricidad.jpg";
import electronicaImg from "../assets/images/programas_estudio/electronica.jpg";
import gestionImg from "../assets/images/programas_estudio/gestion.jpg";
import mecanicaImg from "../assets/images/programas_estudio/mecanica.jpg";
import mecatronicaImg from "../assets/images/programas_estudio/mecatronica.jpg";

function Home() {

  const [showModal, setShowModal] = useState(false); 
  const closeModal = () => setShowModal(false);     

  useEffect(() => {
    setTimeout(() => setShowModal(true), 1200);
  }, []);

    useEffect(() => {
    const hash = window.location.hash.replace("#", "");
    if (hash) {
      setTimeout(() => {
        const target = document.getElementById(hash);
        if (target) {
          window.scrollTo({
            top: target.offsetTop - 100, 
            behavior: "smooth",
          });
        }
      }, 400);
    }
  }, []);
  
  return (
    <>

      {/*  Modal Publicitario */}
      {showModal && (
        <div className="publicidad-overlay" onClick={closeModal}>
          <div className="publicidad-modal" onClick={(e) => e.stopPropagation()}>
            <img src={publicidadImg} alt="Publicidad Licenciamiento" className="publicidad-img" />
            <button className="btn-cerrar" onClick={closeModal}>
              CERRAR
            </button>
          </div>
        </div>
      )}

      <BannerSlider/>
      <section id="programas" className="programs-section">
        <div className="container my-5">
          <h2 className="text-center mb-4 text-uppercase fw-bold text-primary">
            Programas de Estudio
          </h2>
          <div className="row">
            <ProgramCard
              title="Construcción Civil"
              img={construccionImg}
              description="Forma profesionales técnicos en planificación, ejecución y control de obras civiles."
            />
            <ProgramCard
              title="Contabilidad"
              img={contabilidadImg}
              description="Capacita en análisis financiero, gestión contable y tributaria."
            />
            <ProgramCard
              title="Desarrollo de Sistemas de Información"
              img={desarrolloImg}
              description="Especialistas en diseño, programación y mantenimiento de software empresarial."
            />
            <ProgramCard
              title="Electricidad Industrial"
              img={electricidadImg}
              description="Prepara técnicos para el mantenimiento e instalación de sistemas eléctricos industriales."
            />
            <ProgramCard
              title="Electrónica Industrial"
              img={electronicaImg}
              description="Desarrolla habilidades en control electrónico, automatización y mantenimiento de equipos."
            />
            <ProgramCard
              title="Gestión Administrativa"
              img={gestionImg}
              description="Profesionales competentes en administración moderna y gestión de recursos empresariales."
            />
            <ProgramCard
              title="Mecánica de Producción Industrial"
              img={mecanicaImg}
              description="Forma técnicos en diseño, mantenimiento y fabricación de maquinaria industrial."
            />
            <ProgramCard
              title="Mecatrónica Automotriz"
              img={mecatronicaImg}
              description="Integra la mecánica, electrónica y control para sistemas automotrices avanzados."
            />
          </div>
        </div>
      </section>
      <AboutSection />
      <StatsSection />      
      <PartnershipsSection />
      <div id="eventos">
      <NewsSection/>
      </div>
      <VideosSection/>
      <PlatformsSection/>
    </>
  );
}

export default Home;
